import {Injectable} from '@angular/core';
import {ProductSearchRequest} from '../../../models/quote/product-search-request';
import {from, Observable} from 'rxjs';
import {ProductsByServicesRequest} from '../../../models/quote/products-by-services-request';
import {map} from 'rxjs/operators';
import {ProductClassificationRequest} from '../../../models/quote/product-classification-request';
import {CmcProductManagerService} from "./cmc-product-manager.service";
import {SqliteCmcProductRepository} from "../../../sqllite/repositories/cmc-products/sqlite-cmc-product.repository";
import {PriceList} from '../../../models/productv2/pricelist.model';
import {ProductWithChildrenV2} from 'src/app/core/models/productv2/productv2-children.model';
import {Page} from 'src/app/core/utils/page';
import {ProductMapperV2Service} from '../product-mapper-v2.service';

@Injectable()
export class StandaloneCmcProductManagerService extends CmcProductManagerService {

    constructor(private sqliteCmcProductRepository: SqliteCmcProductRepository, protected productMapper: ProductMapperV2Service) {
        super(productMapper);
    }

    searchArticles(productSearchRequest: ProductSearchRequest, pageable: Map<string, string>): Observable<Page<ProductWithChildrenV2>> {
        return from(this.sqliteCmcProductRepository.searchArticles(productSearchRequest, pageable)).pipe(
            map(page => {
                const mappedContent = page.content.map(item => this.productMapper.mapToProductWithChildrenV2(item));
                return { ...page, content: mappedContent };
            })
        );
    }

    searchArticlesByFilteredElisCodes(requestData: ProductsByServicesRequest): Observable<{ content: ProductWithChildrenV2[] }> {
        return from(
            this.sqliteCmcProductRepository.findArticlesForDuplication(requestData)
        ).pipe(
            map(responses =>
                responses.flatMap(r =>
                    (r.products ?? []).map(p => this.productMapper.mapToProductWithChildrenV2(p))
                )
            ),
            map(products => ({ content: products }))
        );
    }

    searchClassifications(productClassificationRequest: ProductClassificationRequest): Observable<PriceList[]> {
        return from(this.sqliteCmcProductRepository.getClassificationsByGroupingCodes(productClassificationRequest.classificationGroupingCodes ?? []))
            .pipe(
                map(result => result.map(classification => this.productMapper.mapToPriceList(classification)))
            );
    }

}
